module.exports = __webpack_public_path__ + "components/breadcrumbs/static/chevron-right-12a9a3a95a24f5e0f041326b2913bdc6.svg";